import { AscClusterType } from '@neo.tax/shared';

// Noise and "no root" cluster types: these projects don't carry capitalizable tickets,
// so per-project matching toggles are non-applicable. `DETERMINISTIC_NO_ROOT` is treated
// alongside the two noise types here even though `isAscNoiseClusterType` (server side)
// doesn't include it — the sync pipeline also groups it with noise for the same reason.
export const isNoiseOrNoRootClusterType = (type: AscClusterType | null | undefined): boolean =>
  type === AscClusterType.SmartNoise ||
  type === AscClusterType.CapitalizableProjectNoise ||
  type === AscClusterType.DeterministicNoRoot;
